import { useState } from 'react';

import classNames from 'classnames';
import Checkbox from 'components/ui/Checkbox';
import i18n from 'providers/Locale';

import styles from './TermsSummary.module.scss';

type TermsSummaryProps = {
	className?: string;
	companyName: string;
	onChange: (status: boolean) => void;
	checked?: boolean;
};

export const TermsSummary: React.FC<TermsSummaryProps> = ({
	className,
	companyName,
	onChange,
	checked,
}) => {
	const [showMore, setShowMore] = useState(false);

	return (
		<div className={classNames(styles.root, className)}>
			<div className={styles.body}>
				<Checkbox appearance="classic" checked={checked} onChange={onChange} />
				<div className={styles.text} style={{ minHeight: showMore ? 'auto' : '40px' }}>
					{i18n('confirm_order.allowMarketing', { name: companyName })}
					{showMore && (
						<>
							<br />
							<br />
							{i18n('confirm_order.allowMarketingMore', {
								name: companyName,
							})}
						</>
					)}{' '}
					<span onClick={setShowMore.bind(null, !showMore)}>
						{' '}
						{showMore ? i18n('hide') : i18n('more')}
					</span>
				</div>
			</div>
		</div>
	);
};
